const CACHE_KEY = 'tb2_user_state';
const CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

export function getCachedState() {
    try {
        const cached = JSON.parse(localStorage.getItem(CACHE_KEY));
        if (!cached) return null;
        if (Date.now() - new Date(cached.cachedAt).getTime() > CACHE_TTL_MS) return null;
        return cached.state;
    } catch {
        return null;
    }
}

let _pendingFetch = null;

export async function initUserState() {
    if (getCachedState() !== null) return;
    if (_pendingFetch) return _pendingFetch;
    _pendingFetch = (async () => {
        try {
            const res = await fetch(process.env.REACT_APP_TB2_API_URL + '/events/geolocation/state');
            const state = res.ok ? (await res.json())?.state ?? 'Not available' : 'Not available';
            localStorage.setItem(CACHE_KEY, JSON.stringify({ state, cachedAt: new Date().toISOString() }));
        } catch {
            localStorage.setItem(CACHE_KEY, JSON.stringify({ state: 'Not available', cachedAt: new Date().toISOString() }));
        } finally {
            _pendingFetch = null;
        }
    })();
    return _pendingFetch;
}
